var _rect, _path, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatus2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.80005,
    y: 1.2,
    width: 25,
    height: 25,
    rx: 9,
    fill: "#DFE1E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3332 7.09402H14.2663C12.4349 7.09402 10.9517 8.55429 10.9517 10.3574V12.0385H12.6257V10.3738C12.6257 9.47231 13.3673 8.74218 14.283 8.74218H14.3165C15.2322 8.74218 15.9737 9.47231 15.9737 10.3738V12.0385H17.6477V10.3574C17.6477 8.55429 16.1646 7.09402 14.3332 7.09402ZM10.9517 12.0385H12.6257V13.6866H10.9517V12.0385ZM15.9737 12.0385H17.6477V13.6866H15.9737V12.0385ZM15.9741 13.6866H12.6261H10.9521C10.028 13.6866 9.27808 14.425 9.27808 15.3348V17.807C9.27808 19.1724 10.3913 20.2792 11.7609 20.2792H16.8393C18.2105 20.2792 19.3221 19.1819 19.3221 17.807V15.3348C19.3221 14.425 18.5721 13.6866 17.6481 13.6866H15.9741Z",
    fill: "#42526E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.80005,
    y: 1.2,
    width: 25,
    height: 25,
    rx: 9,
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatus2);
export default __webpack_public_path__ + "static/media/Status(2).3720e0acd79b37bd412bc7d7faf5c417.svg";
export { ForwardRef as ReactComponent };